import { createGlobalStyle } from 'styled-components';

export const theme = {
  primary:      '#615DFF',
  accent:       '#3DD9EB',
  bg:           '#07080F',
  surface:      '#0D0E1E',
  surfaceAlt:   '#0A0B18',
  border:       'rgba(255,255,255,0.08)',
  borderHover:  'rgba(97,93,255,0.35)',
  text:         '#F0F0FF',
  textMuted:    'rgba(240,240,255,0.55)',
  textDim:      'rgba(240,240,255,0.35)',
  gradient:     'linear-gradient(135deg, #615DFF 0%, #3DD9EB 100%)',
  gradientHov:  'linear-gradient(135deg, #7571FF 0%, #55E5F5 100%)',
  glow:         '0 0 40px rgba(97,93,255,0.25)',
  cardBg:       'rgba(255,255,255,0.03)',
  cardBgHover:  'rgba(97,93,255,0.07)',
  cardShadow:   '0 4px 24px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.05)',
};

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html { scroll-behavior: smooth; }

  body {
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
    line-height: 1.6;
    color: ${theme.text};
    background-color: ${theme.bg};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::selection {
    background: rgba(97,93,255,0.35);
    color: #fff;
  }

  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: ${theme.bg}; }
  ::-webkit-scrollbar-thumb {
    background: rgba(97,93,255,0.4);
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover { background: rgba(97,93,255,0.65); }

  a { text-decoration: none; color: inherit; }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  img { max-width: 100%; height: auto; }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
    color: ${theme.text};
  }

  p {
    margin-bottom: 1rem;
    color: ${theme.textMuted};
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  section { padding: 5rem 0; }
`;

export default GlobalStyles;
